import Navbar from "./Navbar.js";
import BookNow from "./BookNow.js";
import Choose from "./Choose.js";
import Footer from './Footer.js';
import landingPage from "../images/landingpage.jpg";
import bg from "../images/hero-bg.png";
import car5 from "../images/car5.png";
import { Button, Grid } from '@mui/material';
import '../App.css';
import Reviews from "./Reviews.js";

export default function Home() {
    const mainColor = '#FF4D30'
    return (
        <div>
            <Navbar />
            <section id="Home" class="hero-section">
                <div className="container">
                    <img class="hero-bg" src={bg} alt="bg" />
                    <div class="hero-content">
                        <img class="hero-img" src={car5} alt="red car" />
                        <div class="hero-content__text">
                            <h4>Plan your trip now</h4>
                            <h1>Save <span>BIG</span> with our car rentals</h1>
                            <p>Rent the car of your dreams. Unbeatable prices, unlimited miles, flexible pick-up options and much more.</p>
                            <Grid container spacing={2} sx={{ justifyContent: { xs: "center", sm: "flex-start" } }}>
                                <Grid item>
                                    <Button href="#bookNow" sx={{
                                        minWidth: 160,
                                        backgroundColor: mainColor, zIndex: 3, p: 2, px: '2rem', '&:hover': {
                                            backgroundColor: mainColor,
                                            color: 'white',
                                        }
                                    }} variant="contained">Book Now</Button>
                                </Grid>
                                <Grid item>
                                    <Button href="#choose-section" sx={{
                                        backgroundColor: 'black', color: 'white', borderColor: 'black', zIndex: 3, p: 2, px: '2rem', '&:hover': {
                                            backgroundColor: 'black',
                                            color: 'white',
                                            borderColor: 'black'
                                        }
                                    }} variant="contained">Learn More</Button>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </section>
            <section id="bookNow">
                <div class="container">
                    <BookNow mainColor={mainColor} />
                </div>
            </section>
            <section id="choose-section">
                <Choose />
            </section>
            <section id="reviews">
                <Reviews />
            </section>
            <section id="footer">
                <Footer />
            </section>
        </div>
    );
}